import { useFormStore } from '../../../../../../../store/use-form-store';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useInputLangStore } from '../../../../../../../store/use-input-lang-store';

import { FormElementType } from '../../../../../../../store/api/forms-api';
import { MultiSelect } from '../../../../../../../features/multi-select/multi-select';

interface Props {
  formElement?: Partial<FormElementType>;
}

export const FormCreateMultiSelect = ({ formElement }: Props) => {
  const { getLocale } = useLang();
  const { newElement } = useFormStore();
  const { language } = useInputLangStore();

  const options = formElement ? formElement?.info?.options : newElement?.info?.options;
  const helperText = formElement ? formElement.info?.helper_text : newElement?.info?.helper_text;
  const helper = formElement ? formElement.info?.helper : newElement?.info?.helper;

  return (
    <MultiSelect
      onSelect={() => {}}
      style={{ minWidth: '200px' }}
      options={
        options?.map((item, index) => ({
          id: index.toString(),
          value: getLocale(item, language),
        })) || []
      }
      placeholder={helper === 'placeholder' ? getLocale(helperText, language) : undefined}
    />
  );
};
